<template>
  <div class="tabs" role="group" :aria-label="label">
    <button v-for="option in options" :key="option.value" type="button" class="tab" :class="{active: option.value === value}" :aria-pressed="option.value === value" @click="callback(option.value)">{{ option.label }}</button>
  </div>
</template>

<script>
/**
 * Choix d'une période parmi quelques boutons (1 h, 6 h, 24 h...).
 * options : [{value, label}] ; value : période choisie ; callback : appelé avec la valeur du bouton cliqué.
 */
export default {
  name: 'RangeTabs',
  props: {
    options: {type: Array, required: true},
    value: {type: String, required: true},
    callback: {type: Function, required: true},
    label: {type: String, default: 'Période'},
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.tabs
  display inline-flex
  flex-wrap wrap
  gap 4px
  padding 3px
  background CTRL_BG
  border 1px solid CTRL_BORDER
  border-radius 10px

.tab
  padding 5px 12px
  font inherit
  font-size 13px
  font-weight 600
  color CTRL_TEXT_MUTED
  cursor pointer
  background transparent
  border 0
  border-radius 8px

  &:hover
    color THEME_COLOR_PRIMARY

  &.active
    color white
    background THEME_COLOR_PRIMARY
</style>
